import React, { useState } from 'react';
import { bool, shape, string } from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import ScoringErrorModal from './ScoringErrorModal';

import defaultClasses from '../../components/RuleExceptionsTable/ContextMenu.module.css';

const DEFAULT_MODAL_STATE = Object.freeze({
    exceptionViewer: false
});

const ScoringContextMenu = ({ error, hidden }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [modalStates, setModalStates] = useState({ ...DEFAULT_MODAL_STATE });
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleModalClose() {
        setModalStates({ ...DEFAULT_MODAL_STATE });
        handleClose();
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleViewRuleError() {
        setModalStates({
            exceptionViewer: true
        });
        handleClose();
    }

    return (
        <>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                    onClick={handleViewRuleError}
                >
                    <img
                        alt=""
                        className={defaultClasses.menuItemIcon}
                        src="/assets/images/ruleErrorIconColor.svg"
                    />
                    View Full Error Message
                </MenuItem>
            </Menu>
            <ScoringErrorModal
                error={error}
                onConfirm={handleModalClose}
                onClose={handleModalClose}
                open={modalStates.exceptionViewer}
            />
        </>
    );
};

ScoringContextMenu.defaultProps = {
    hidden: false
};

ScoringContextMenu.propTypes = {
    hidden: bool,
    rule:   shape({
        id: string
    })
};

export default ScoringContextMenu;
